import { Link, makeStyles, withStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  mainDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    padding: "15px 20px",
  },
  dataItemColumnContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  dataItemRowContainer: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  dataItemLabel: { fontWeight: 500, fontSize: "14px" },
  dataItem: {
    fontSize: "14px",
    wordBreak: "break-all",
  },
  cardsContainer: {
    marginTop: 10,
    marginBottom: 20,
    width: "100%",
    display: "flex",
    gap: "20px",
    paddingLeft: 16,
  },
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    padding: "15px 20px",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    boxShadow: "none",
  },
  cardText: { fontWeight: 500, fontSize: "14px" },
  dataItemPopoverPaper: {
    padding: "10px 0",
    overflow: "scroll",
    maxHeight: "280px",
  },
});

export const GoBackLink = withStyles({
  root: {
    alignSelf: "flex-start",
    "&[disabled]": {
      color: "grey",
      cursor: "default",
      opacity: "0.5",
      "&:hover": {
        textDecoration: "none",
      },
    },
  },
})(Link);
